import { FC, SVGAttributes } from "react";

const GPayIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google Pay</title>
    <path
      d="M4.12903 0.5H27.871C29.8701 0.5 31.5 2.13976 31.5 4.17391V19.8261C31.5 21.8602 29.8701 23.5 27.871 23.5H4.12903C2.12986 23.5 0.5 21.8602 0.5 19.8261V4.17391C0.5 2.13976 2.12986 0.5 4.12903 0.5Z"
      fill="white"
      stroke="#EEEEEE"
    />
    <path
      d="M15.3438 12.7368V15.5259H14.4441V8.62805H16.7834C17.3532 8.62805 17.893 8.83799 18.3129 9.22786C18.7327 9.58775 18.9427 10.1276 18.9427 10.6974C18.9427 11.2672 18.7327 11.7771 18.3129 12.1669C17.893 12.5568 17.3832 12.7668 16.7834 12.7668L15.3438 12.7368ZM15.3438 9.46779V11.867H16.8433C17.1732 11.867 17.5031 11.7471 17.7131 11.5071C18.1929 11.0573 18.1929 10.3075 17.7431 9.85767L17.7131 9.82768C17.4731 9.58775 17.1732 9.4378 16.8433 9.46779H15.3438Z"
      fill="#5F6368"
    />
    <path
      d="M21.0121 10.6674C21.6719 10.6674 22.1817 10.8474 22.5716 11.2073C22.9615 11.5671 23.1414 12.047 23.1414 12.6468V15.5259H22.3017V14.8661H22.2717C21.9118 15.4059 21.402 15.6759 20.8022 15.6759C20.2923 15.6759 19.8425 15.5259 19.4826 15.226C19.1527 14.9261 18.9427 14.5062 18.9427 14.0564C18.9427 13.5765 19.1227 13.1866 19.4826 12.8867C19.8425 12.5868 20.3523 12.4669 20.9521 12.4669C21.492 12.4669 21.9118 12.5568 22.2417 12.7668V12.5568C22.2417 12.2569 22.1218 11.957 21.8818 11.7771C21.6419 11.5671 21.342 11.4472 21.0121 11.4472C20.5023 11.4472 20.1124 11.6571 19.8425 12.077L19.0627 11.5971C19.5426 10.9673 20.1724 10.6674 21.0121 10.6674ZM19.8725 14.0863C19.8725 14.3263 19.9924 14.5362 20.1724 14.6562C20.3823 14.8061 20.6222 14.8961 20.8621 14.8961C21.222 14.8961 21.5819 14.7461 21.8518 14.4762C22.1517 14.2063 22.3017 13.8764 22.3017 13.5165C22.0318 13.3066 21.6419 13.1866 21.1321 13.1866C20.7722 13.1866 20.4723 13.2766 20.2323 13.4565C19.9924 13.6065 19.8725 13.8164 19.8725 14.0863Z"
      fill="#5F6368"
    />
    <path
      d="M28 10.8173L25.031 17.6252H24.1312L25.2409 15.2559L23.2915 10.8473H24.2512L25.6608 14.2363H25.6908L27.0703 10.8473H28V10.8173Z"
      fill="#5F6368"
    />
    <path
      d="M11.7751 12.137C11.7751 11.867 11.7451 11.5971 11.7151 11.3272H7.96631V12.8567H10.0956C10.0057 13.3366 9.73575 13.7864 9.31589 14.0564V15.046H10.6055C11.3552 14.3563 11.7751 13.3366 11.7751 12.137Z"
      fill="#4285F4"
    />
    <path
      d="M7.96638 16.0056C9.04604 16.0056 9.94576 15.6457 10.6056 15.0459L9.31596 14.0562C8.95607 14.2962 8.50621 14.4461 7.96638 14.4461C6.9467 14.4461 6.04698 13.7563 5.74708 12.7966H4.42749V13.8163C5.11727 15.1659 6.46685 16.0056 7.96638 16.0056Z"
      fill="#34A853"
    />
    <path
      d="M5.74695 12.7967C5.56701 12.3168 5.56701 11.777 5.74695 11.2672V10.2475H4.42737C3.85754 11.3571 3.85754 12.6767 4.42737 13.8164L5.74695 12.7967Z"
      fill="#FBBC04"
    />
    <path
      d="M7.9663 9.64767C8.53612 9.64767 9.07595 9.85761 9.49582 10.2475L10.6355 9.10784C9.91569 8.44805 8.95599 8.05817 7.99629 8.08816C6.49676 8.08816 5.11719 8.9279 4.4574 10.2775L5.77698 11.2972C6.0469 10.3375 6.94662 9.64767 7.9663 9.64767Z"
      fill="#EA4335"
    />
  </svg>
);

export default GPayIconBackground;
